module.exports = __webpack_public_path__ + "img/montenegro.50eeaba1.svg";